import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
// Crypto Redux States
import { UsersTypes } from './actionTypes';
import {
  getUsersSuccess,
  getUsersFail,
  addUsersFail,
  addUsersSuccess,
  deleteUsersSuccess,
  updateUsersSuccess,
  deleteUsersFail,
  updateUsersFail,
  setNewPasswordRequestSucess,
  updatePasswordRequestSucess,
} from './actions';

import apiFetch from '../../fetch';
import * as url from '../../helpers/url_helper';

export const fetchUsers = async (data: any) => {
  const { sizePerPage, page } = data?.pagination ?? {
    sizePerPage: 50,
    page: 1,
  };

  let textClient = '';
  let textRol = '';
  let textNetworkId = '';
  let textName = '';
  let textLastName = '';
  let textEmail = '';

  if (data.filter) {
    textClient = data.filter['Search Client ID'];
    textRol = data.filter['Search Rol Id'];
    textNetworkId = data.filter['Search NetworkId'];
    textName = data.filter['Search Name'];
    textLastName = data.filter['Search Last Name'];
    textEmail = data.filter['Search Email'];
  }
  const path = url.API_URL;

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
        Users(FilterEmpresaID:{userId:${user.id}},
			filter:{
				${textClient ? `EMPRESA_ID:${textClient}` : ''}
				${textRol ? `,ROL_ID:"${textRol}"` : ''}
				${textNetworkId ? `,NETWORK_ID:${textNetworkId}` : ''}
				${textName ? `,USUARIO_NOMBRE:"${textName}"` : ''}
				${textLastName ? `,USUARIO_APELLIDO:"${textLastName}"` : ''}
				${textEmail ? `,USUARIO_CORREO:"${textEmail}"` : ''}
			}
			){
          id
          USUARIO_ID
          NETWORK_ID
          ACCOUNT_NUMBER
          USUARIO_NOMBRE
          USUARIO_APELLIDO
          USUARIO_CORREO
          USUARIO_TELEFONO
          USUARIO_ACTIVO
          USUARIO_LOGIN
          USUARIO_PASSWORD
          USUARIO_ELIMINADO
          EMPRESA_ID
          PUNTO_ID
          CIUDAD_ID
          FECHA_CREACION
          MCA_EMPLEADO
          NOMBRE_CIUDAD
          NOMBRE_DIRECCION
          CELULAR
          URL_FOTO_PERFIL
          STATUS_ONLINE
          LATITUD
          LONGITUD
          USUARIO_TOKEN
          USUARIO_NACIMIENTO
          USUARIO_SEXO
          FECHA_REGISTRO
          COUNTRY
          CODIGOINTERNACIONAL
          BANDERA
          IDIOMA_ID
          ROL_ID
          NUMERO_INTENTOS
          MCA_BLOQUEADO_INTENTOS
          CEDULA
          SUB_ENTITIES
          INNOBOKEY
          createdAt
          updatedAt
        }
      }
      `;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.Users;
};

function* getUsersSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchUsers, data.payload);
    yield put(getUsersSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getUsersFail(error));
  }
}

export const fetchUsersEmail = async (data: any) => {
  const path = url.API_URL;
  const query = `query {
        GetUserByEmail(Email:{USUARIO_CORREO:"${data?.email}"}){
          id
          USUARIO_ID
          NETWORK_ID
          ACCOUNT_NUMBER
          USUARIO_NOMBRE
          USUARIO_APELLIDO
          USUARIO_CORREO
          USUARIO_TELEFONO
          USUARIO_ACTIVO
          USUARIO_LOGIN
          USUARIO_PASSWORD
          USUARIO_ELIMINADO
          EMPRESA_ID
          PUNTO_ID
          CIUDAD_ID
          FECHA_CREACION
          MCA_EMPLEADO
          NOMBRE_CIUDAD
          NOMBRE_DIRECCION
          CELULAR
          URL_FOTO_PERFIL
          STATUS_ONLINE
          LATITUD
          LONGITUD
          USUARIO_TOKEN
          USUARIO_NACIMIENTO
          USUARIO_SEXO
          FECHA_REGISTRO
          COUNTRY
          CODIGOINTERNACIONAL
          BANDERA
          IDIOMA_ID
          ROL_ID
          NUMERO_INTENTOS
          MCA_BLOQUEADO_INTENTOS
          CEDULA
          SUB_ENTITIES
          INNOBOKEY
        }
      }
      `;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.GetUserByEmail;
};

function* getUsersEmailSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchUsersEmail, data.payload);
    yield put(getUsersSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(getUsersFail(error));
  }
}

export const addUsersList = async ({ payload: { usersAdd } }: any) => {
  const urlHost = window.location.origin;
  const {
    COMPANY_ID,
    INNOBOKEY,
    ROLE_ID,
    SUB_ENTITIES,
    USER_NAME,
    USER_LAST_NAME,
    USER_PASSWORD,
    USER_ACTIVE,
    USER_EMAIL,
    NETWORK_ID,
  } = usersAdd.users;

  const query = `mutation {
    createUser( Users:  {
		NETWORK_ID:${NETWORK_ID}
        USUARIO_NOMBRE: "${USER_NAME}",
        USUARIO_APELLIDO:"${USER_LAST_NAME}",
        USUARIO_PASSWORD:"${USER_PASSWORD}",
        USUARIO_CORREO:"${USER_EMAIL}",
        ROL_ID:${ROLE_ID ? `"${ROLE_ID}"` : null},
        EMPRESA_ID:${COMPANY_ID},
        USUARIO_ACTIVO:${USER_ACTIVE},
        SUB_ENTITIES:${
          SUB_ENTITIES ? '"' + SUB_ENTITIES.replace(/"/g, '\\"') + '"' : null
        },
        INNOBOKEY:"${INNOBOKEY}",
		url: "${urlHost}",
    })   
  }`;

  const respon = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return respon.data;
};

function* addUsersSaga(user: any) {
  const { pagination } = user.payload.usersAdd;
  try {
    const response: Promise<any> = yield call(addUsersList, user);
    yield put(addUsersSuccess(response));

    const response2: Promise<any> = yield call(fetchUsers, { pagination });
    yield put(getUsersSuccess(response2));
  } catch (error) {
    yield put(addUsersFail(error));
  }
}

export const deleteUsersList = async (id: any) => {
  const path = url.API_URL;
  const query = `mutation{
		deleteUser(Users: {
      id: ${id}
     })
  }`;

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response.data.deleteUsers;
};

function* deleteUsersSaga({ payload }: any) {
  const { id, pagination } = payload;
  try {
    const response: Promise<any> = yield call(deleteUsersList, id);
    yield put(deleteUsersSuccess(response));
    const response2: Promise<any> = yield call(fetchUsers, { pagination });
    yield put(getUsersSuccess(response2));
  } catch (error) {
    console.log(error);
    yield put(deleteUsersFail(error));
  }
}

function* updateUsersList(action: any): any {
  const { payload } = action;
  const { pagination } = payload.users;
  const path = url.API_URL;
  const {
    id,
    USER_NAME,
    USER_LAST_NAME,
    USER_PASSWORD,
    USER_EMAIL,
    ROLE_ID,
    COMPANY_ID,
    USER_ACTIVE,
    INNOBOKEY,
    NETWORK_ID,
  } = payload.users.users;

  let {SUB_ENTITIES} = payload.users.users;

  if (typeof SUB_ENTITIES === 'string') {
    SUB_ENTITIES = JSON.parse(SUB_ENTITIES);
}

  // La clave solo se manda si se escribio una nueva (el servidor ya no devuelve la actual).
  const lineaClave = USER_PASSWORD ? `USUARIO_PASSWORD: "${USER_PASSWORD}",` : '';

  const query = `mutation {  
    updateUser(Users: {
        id: ${id},
        USUARIO_NOMBRE: "${USER_NAME}",
        USUARIO_APELLIDO: "${USER_LAST_NAME}",
        ${lineaClave}
        USUARIO_CORREO: "${USER_EMAIL}",
        ROL_ID: ${ROLE_ID ? `"${ROLE_ID}"` : null},
        EMPRESA_ID: ${COMPANY_ID},
        USUARIO_ACTIVO: ${USER_ACTIVE},
        SUB_ENTITIES: ${SUB_ENTITIES && SUB_ENTITIES[0] != "" ? '"' + JSON.stringify(SUB_ENTITIES).replace(/"/g, '\\"') + '"':null},
        INNOBOKEY: "${INNOBOKEY}",
        NETWORK_ID: ${NETWORK_ID}
    }) {
        id
        USUARIO_NOMBRE
        USUARIO_APELLIDO
        USUARIO_PASSWORD
        USUARIO_CORREO
        ROL_ID
        EMPRESA_ID
        USUARIO_ACTIVO
        SUB_ENTITIES
        INNOBOKEY
    }
}`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resp: any = yield call(apiFetch, path, opts);

    const response2: Promise<any> = yield call(fetchUsers, {
      pagination,
      filter: payload.users.filter,
    });
    yield put(getUsersSuccess(response2));
  } catch (error) {
    yield put(updateUsersFail(error));
  }
}

function* updateUserPasswordList(action: any): any {
  const { payload } = action;
  const path = url.API_URL;
  let idUser = 0;
  let password = '';
  if (payload.users.select) {
    const { id, USUARIO_PASSWORD } = payload.users;
    idUser = id;
    password = USUARIO_PASSWORD;
  } else {
    const { id, USUARIO_PASSWORD } = payload.users.users;
    idUser = id;
    password = USUARIO_PASSWORD;
  }

  const query = `mutation {  
	updateUser ( Users:  {
		id: ${idUser},
        USUARIO_PASSWORD:"${password}",
		USUARIO_TOKEN:null

	})    
	{
		id
		USUARIO_NOMBRE
		USUARIO_APELLIDO
		USUARIO_PASSWORD
		USUARIO_CORREO
		ROL_ID
		EMPRESA_ID
		USUARIO_ACTIVO
		SUB_ENTITIES
		INNOBOKEY
	  }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resp: any = yield call(apiFetch, path, opts);

    yield put(updatePasswordRequestSucess(resp));
  } catch (error) {
    yield put(updateUsersFail(error));
  }
}

function* setRequestPass(action: any): any {
  const { payload } = action;
  const path = url.API_URL;
  const query = `mutation {
        SetForgotPasswordToken( Email:{USUARIO_CORREO:"${payload.email}",url:"${payload.url}"}) {
          message
          success
        }
      }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const resp: any = yield call(apiFetch, path, opts);

    yield put(setNewPasswordRequestSucess(resp));
  } catch (error) {
    yield put(addUsersFail(error));
  }
}

function* UsersSaga() {
  yield takeEvery(UsersTypes.GET_USERS, getUsersSaga);
  yield takeEvery(UsersTypes.GET_USER_EMAIL, getUsersEmailSaga);
  yield takeEvery(UsersTypes.ADD_USERS, addUsersSaga);
  yield takeEvery(UsersTypes.DELETE_USERS, deleteUsersSaga);
  yield takeLatest(UsersTypes.UPDATE_USERS, updateUsersList);
  yield takeLatest(UsersTypes.PASSWORD_REQUEST_USERS, setRequestPass);
  yield takeLatest(
    UsersTypes.PASSWORD_REQUEST_UPDATE_USERS,
    updateUserPasswordList,
  );
}

export default UsersSaga;
